/// <reference types="node" />
export const CLIENT_VERSION = "4.25.0";